import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  ApiURL = environment.ApiURL + '/admin';
  public headers_token: HttpHeaders;
  jwtHelper = new JwtHelperService();

  constructor(private http: HttpClient) {
    this.headers_token = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  }

  login(data: any): Observable<any> {
    const body = JSON.stringify(data);
    return this.http.post(this.ApiURL + '/Login', body, { headers: this.headers_token });
  }

  loggedIn() {
    const token = localStorage.getItem('token');
    if (!this.jwtHelper.isTokenExpired(token)) {
      return true;
    } else {
      return false;
    }
  }

}
